(function () {
  'use strict';

  /* @ngdoc object
   * @name relatorios.coaching
   * @description
   *
   */
  angular
    .module('relatorios.coaching', [
      'ui.router',
      'restangular',
      'angularMoment',
      'FeatureFlagModule',
      'FeatureOuModule',
      'pascalprecht.translate',
      'ServiceVfiltroModule',
      'ObjetosVfiltroModule',
      'FactoryVfiltroModule',
      'ConstantVfiltroModule',
      'UrlModule'
    ]);
}());
